/**
 * Feature main component
 *
 * @author Fabio Dal Santo <fabio@gestionaleauto.com>
 */

/**
 * Main
 */
import React, { useEffect } from 'react';
import HttpStatus from 'http-status-codes';
import Djv from 'djv';
/**
 * Material UI
 */
import { makeStyles } from '@mui/styles';

/**
 * Redux
 */
import { useDispatch, useSelector } from 'react-redux';
import { saveAttachmentTypes, loadConfiguration, loadExternalServices } from '../redux/lookupsSlice';
import { wizardState } from '../redux/wizardSlice';
import { leadState, updateQuoteData } from '../redux/leadSlice';
import serviceSchema from '../helpers/serviceSchema.json';

/**
 * Helpers
 */
import api from '../helpers/api';
import { steps } from '../helpers/const';

/**
 * Components
 */
import WizardEcommerce from './WizardEcommerce';
import Sidebar from './Sidebar';
import ThankYou from './ThankYou';

const useStyles = makeStyles((theme) => ({
  grid: {
    display: 'flex',
    width: '100%',
    maxWidth: '1366px',
    flexDirection: 'column-reverse',
    height: 'auto',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-between',
      flexDirection: 'row',
    },
  },
  child: {
    width: '100%',
    marginBottom: 20,
    [theme.breakpoints.up('md')]: {
      maxWidth: '536px',
      marginBottom: 0,
    },
  },
}));

/**
 * @returns {JSX.Element}
 */
function ECommerceFrontend() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { step } = useSelector(wizardState);
  const { cookie } = useSelector(leadState);

  /**
   * Get AttachmentTypes data from api
   */
  const getAttachmentTypes = async () => {
    const res = await api.get({
      entryPoint: '/attachment_types',
      silentFail: true,
      auth: false,
    });
    if (res?.status === HttpStatus.OK) {
      dispatch(saveAttachmentTypes(res.data.attachment_types));
    }
  };
  /**
   * Get Service list from external URL
   */
  const getServiceListFromExternalUrl = async () => {
    try {
      const { externalServicesURL } = window.ecommerceData;
      const res = await fetch(externalServicesURL.replace('{vehicleId}', window?.ecommerceData.vehicle?.id));
      const externalServices = await res.json();
      const env = new Djv();
      env.addSchema('service', serviceSchema);
      const errorOnValidate = env.validate('service#common', externalServices);
      if (!errorOnValidate) {
        dispatch(loadExternalServices(externalServices));
      } else {
        console.error('Error on validate Schema', errorOnValidate);
      }
    } catch (e) {
      console.error('Error getting external services');
    }
  };
  useEffect(() => {
    dispatch(loadConfiguration({ configuration: window?.ecommerceData }));
    getAttachmentTypes();
    if (window?.ecommerceData?.externalServicesURL) {
      getServiceListFromExternalUrl();
    }
  }, []);

  useEffect(() => {
    if (cookie && cookie.makeId && cookie.makeId !== '') {
      dispatch(updateQuoteData({ ...cookie }));
    }
  }, [cookie]);

  return (
    <div className={classes.grid}>
      <div className={classes.child}>
        <Sidebar />
      </div>
      <div className={classes.child}>
        { step <= steps.paypal && (
          <WizardEcommerce />
        )}
        { step === steps.feedback && <ThankYou /> }
      </div>
    </div>
  );
}

export default ECommerceFrontend;
